/* ghost.icon.svg.js */

"use strict";
module.exports = {
    icon: `
            <svg viewBox="0 0 24 24" preserveAspectRatio="none">
                <path class="foreground-gl" d="M12,2A9,9 0 0,0 3,11V22L6,19L9,22L12,19L15,22L18,19L21,22V11A9,9 0 0,0 12,2M9,8A2,2 0 0,1 11,10A2,2 0 0,1 9,12A2,2 0 0,1 7,10A2,2 0 0,1 9,8M15,8A2,2 0 0,1 17,10A2,2 0 0,1 15,12A2,2 0 0,1 13,10A2,2 0 0,1 15,8Z"/> 
            </svg>
        `,
};
